// TODO: Rather have a map of "type: extension" and use that to generate displayable text
export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif']
export const MAX_FILE_SIZE = 5.5e6 // bytes
